import type { IntakeDraft, IntakeSource } from './aiIntake'

export const RELEVANT_UPLOAD_MESSAGE = 'Please upload relevant property photos, title documents, or brochures.'

// Older API versions saved generic placeholder copy as a property.
export function isPlaceholderDraft(draft: IntakeDraft): boolean {
    const fields = draft.fields
    const hasFacts = ['rawAddress', 'street', 'unitNumber', 'lotNo', 'ownershipNumber', 'city', 'district', 'mukim', 'township', 'landArea', 'builtUp', 'price', 'noOfBedrooms'].some((key) => {
        const value = fields[key]
        return typeof value === 'number' ? value > 0 : typeof value === 'string' && value.trim() !== ''
    })
    return !hasFacts && /^(?:draft\s+)?property listing\s+(?:pending|awaiting|missing)/i.test(String(fields.headline || '').trim())
}

export function isRejectedUpload(sources: IntakeSource[]): boolean {
    return sources.length > 0 && sources.every((source) => source.documentType === 'irrelevant')
}

export function reviewableDrafts(drafts: IntakeDraft[], completed: number[]) {
    return drafts.map((draft, index) => ({ draft, index })).filter(({ draft, index }) => completed.includes(index) || !isPlaceholderDraft(draft))
}
